import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppAnalysisService } from '../../../../src/app/app-analysis-module/app-analysis.service';


@Component({
  selector: 'app-share-link-and-embed-modal',
  templateUrl: './share-link-and-embed-modal.component.html',
  styleUrls: ['./share-link-and-embed-modal.component.css']
})

export class ShareLinkAndEmbedModalComponent implements OnInit {

  mapShareUrl:any;
  shareType: any;

  constructor(public dialogRef: MatDialogRef<ShareLinkAndEmbedModalComponent>,
    private AppAnalysisService:AppAnalysisService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.mapShareUrl = data.url
    this.shareType = data.shareType   
   }

  ngOnInit() {
  }
  closelinkEmbedModal(){
    this.dialogRef.close();
  }
  /* To copy Text from Textbox */
  copyInputMessage(element: { select: () => void; }){
    element.select();
    document.execCommand('copy');
    console.log('copied text!!!!!!!!!!! ',element )    
  }
 previewShareMap(){
  window.open(this.mapShareUrl)
  this.dialogRef.close();
  }
  
}
